"use strict";

exports.__esModule = true;
exports.Autocomplete = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _TextInput = require("../../Form/TextInput/TextInput");
var _Text = require("../../Elements/Text/Text");
var _FormattedComposite = require("../../Elements/FormattedComposite/FormattedComposite");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Autocomplete = ({
  config,
  data,
  labels
}) => {
  const {
    minSearchLength = 3,
    itemCount = 5,
    onKeyPress,
    onSelect,
    displayFormats,
    title,
    summary
  } = config;
  const dataTruncated = data.slice(0, itemCount);
  const [showResultsBox, setShowResultsBox] = (0, _react.useState)(false);
  const [resultsData, setResultsData] = (0, _react.useState)(dataTruncated);
  const resultsBoxRef = (0, _react.useRef)();
  const formik = (0, _formik.useFormik)({
    initialValues: {
      q: ''
    }
  });
  const handleChange = value => {
    if (value.length >= minSearchLength) {
      onKeyPress(value);
    } else {
      setShowResultsBox(false);
    }
  };
  const handleSelect = id => {
    setShowResultsBox(false);
    onSelect(id);
  };
  (0, _react.useEffect)(() => {
    if (data.length > 0) {
      setResultsData(dataTruncated);
      setShowResultsBox(true);
    } else {
      setShowResultsBox(false);
      setResultsData([]);
    }
  }, [data]);
  const ResultsBox = ({
    data
  }) => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl__resultsBox",
      ref: resultsBoxRef,
      children: data.map(d => {
        let formattedCompositeConfig = {};
        let formattedCompositeData = {};
        let hasAddress = false;
        let name = '';
        d.fields.forEach(field => {
          if (field.type === 'string') name = field.value;
          if (field.type === 'address') {
            hasAddress = true;
            let format = '';
            displayFormats.forEach(displayFormat => {
              if (displayFormat.countries.includes(field.value.countryName)) format = displayFormat.format;
            });
            formattedCompositeConfig = {
              type: 'composite',
              format
            };
            const overrideKeys = {
              countryName: 'country',
              postcode: 'zip'
            };
            // eslint-disable-next-line array-callback-return
            Object.entries(field.value).map(([key, value]) => {
              if (Object.keys(overrideKeys).includes(key)) {
                // eslint-disable-next-line no-param-reassign
                key = overrideKeys[key];
              }
              formattedCompositeData[key] = {
                value,
                type: 'string',
                format: null
              };
            });
          }
        });
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "ccl__resultsBox--row",
          onClick: () => handleSelect(d.id),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
            content: name
          }), hasAddress && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.FormattedComposite, {
            config: formattedCompositeConfig,
            data: formattedCompositeData
          })]
        }, d.id);
      })
    });
  };
  const useDetectOutside = (ref, callback) => {
    (0, _react.useEffect)(() => {
      const handleClickOutside = e => {
        if (ref.current && !ref.current.contains(e.target)) {
          callback();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };
  useDetectOutside(resultsBoxRef, () => {
    setShowResultsBox(false);
    setResultsData([]);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
    autoComplete: "off",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
      content: labels[title],
      type: "body-text-bold"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
      content: labels[summary],
      type: "small-body-text-italic"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
      name: "q",
      promptText: "",
      onChange: e => {
        formik.handleChange(e);
        handleChange(e.target.value);
      },
      value: formik.values.q
    }), showResultsBox && /*#__PURE__*/(0, _jsxRuntime.jsx)(ResultsBox, {
      data: resultsData
    })]
  });
};
exports.Autocomplete = Autocomplete;